// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results {
  flex-grow: 1;
  transition: 0.25s;
  /* margin: 4px 4px 0px -18px; */
}

.results .MuiDataGrid-main {
  /* border: 1px solid rgba(224, 224, 224, 1); */
  border-radius: var(--radius-small);
  height: calc(90%);
  background-color: #f8f8f8;
  gap: 10px;
  display: flex;
  flex-direction: column;

  min-height: 0;
  overflow: hidden auto;

  border: 1px solid #e0e0e0;
  /* overflow-y: scroll; */
  /* overflow-wrap: break-word; */
  /* max-height: 80%;   */
  /* max-width: 100%;
  bottom: 10px */

  
}

@supports (-moz-appearance: none) {

  /*
    Give the scrollbar 10px margin on Firefox
    since it doesn't support custom scrollbar
  */
  .results .MuiDataGrid-main {
    /* padding: 20px; */
    margin: 0 10px;
  }
}

.results .content__header .options .button:not(.icon) {
  background-color: var(--button-bg-darker);
}

.results .prompt__container .sidebar__select {
  padding: 0;
}

.results.group .prompt__backdrop {
  z-index: 0;
  height: 100%;
  position: unset;
  background: white;
}

.results.group .prompt__backdrop>.prompt__container {
  box-shadow: 0 0 15px 5px var(--button-bg-darker);
}


/* IP Address + Port Number text input */

.results .prompt__container .loc__port input[type="numeric"],
.results .prompt__container .loc__port input[type="numeric"] {
  outline: 0;
  border: none;
  max-width: 40px;
  margin-right: 2px;
  text-align: center;
}


/* Print Report --- smaller for accounts and locations */

.results:not(.groups) #print th,
.results:not(.groups) #print td {
  font-size: 11px;
}



.results .container__header {
  gap: 5px;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr auto;
  justify-content: space-between;
}

.results .container__title {
  font-size: 15x;
  transition: 0s;

  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;

  gap: 5px;
  flex-grow: 1;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/Main/Resultat/Result.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;EAC9C,kCAAkC;EAClC,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,sBAAsB;;EAEtB,aAAa;EACb,qBAAqB;;EAErB,yBAAyB;EACzB,wBAAwB;EACxB,+BAA+B;EAC/B,uBAAuB;EACvB;gBACc;;;AAGhB;;AAEA;;EAEE;;;GAGC;EACD;IACE,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;AAClD;;;AAGA,wCAAwC;;AAExC;;EAEE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA,wDAAwD;;AAExD;;EAEE,eAAe;AACjB;;;;AAIA;EACE,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,cAAc;;EAEd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;;EAEjB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".results {\r\n  flex-grow: 1;\r\n  transition: 0.25s;\r\n  /* margin: 4px 4px 0px -18px; */\r\n}\r\n\r\n.results .MuiDataGrid-main {\r\n  /* border: 1px solid rgba(224, 224, 224, 1); */\r\n  border-radius: var(--radius-small);\r\n  height: calc(90%);\r\n  background-color: #f8f8f8;\r\n  gap: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  min-height: 0;\r\n  overflow: hidden auto;\r\n\r\n  border: 1px solid #e0e0e0;\r\n  /* overflow-y: scroll; */\r\n  /* overflow-wrap: break-word; */\r\n  /* max-height: 80%;   */\r\n  /* max-width: 100%;\r\n  bottom: 10px */\r\n\r\n  \r\n}\r\n\r\n@supports (-moz-appearance: none) {\r\n\r\n  /*\r\n    Give the scrollbar 10px margin on Firefox\r\n    since it doesn't support custom scrollbar\r\n  */\r\n  .results .MuiDataGrid-main {\r\n    /* padding: 20px; */\r\n    margin: 0 10px;\r\n  }\r\n}\r\n\r\n.results .content__header .options .button:not(.icon) {\r\n  background-color: var(--button-bg-darker);\r\n}\r\n\r\n.results .prompt__container .sidebar__select {\r\n  padding: 0;\r\n}\r\n\r\n.results.group .prompt__backdrop {\r\n  z-index: 0;\r\n  height: 100%;\r\n  position: unset;\r\n  background: white;\r\n}\r\n\r\n.results.group .prompt__backdrop>.prompt__container {\r\n  box-shadow: 0 0 15px 5px var(--button-bg-darker);\r\n}\r\n\r\n\r\n/* IP Address + Port Number text input */\r\n\r\n.results .prompt__container .loc__port input[type=\"numeric\"],\r\n.results .prompt__container .loc__port input[type=\"numeric\"] {\r\n  outline: 0;\r\n  border: none;\r\n  max-width: 40px;\r\n  margin-right: 2px;\r\n  text-align: center;\r\n}\r\n\r\n\r\n/* Print Report --- smaller for accounts and locations */\r\n\r\n.results:not(.groups) #print th,\r\n.results:not(.groups) #print td {\r\n  font-size: 11px;\r\n}\r\n\r\n\r\n\r\n.results .container__header {\r\n  gap: 5px;\r\n  display: grid;\r\n  grid-auto-flow: column;\r\n  grid-auto-columns: 1fr auto;\r\n  justify-content: space-between;\r\n}\r\n\r\n.results .container__title {\r\n  font-size: 15x;\r\n  transition: 0s;\r\n\r\n  cursor: pointer;\r\n  user-select: none;\r\n\r\n  gap: 5px;\r\n  flex-grow: 1;\r\n  display: flex;\r\n  align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
